module.exports = __webpack_public_path__ + "img/hr-sand-decal-18.534ee4af.png";